// import React, { useState, useEffect } from 'react';
// import './ServiceRequestItemForm.scss';
// import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
// import { FxInput, http, general, useNavigationService, localstorage, session, AlertService } from '../../../fx-core';
// import ItemCard from '../ItemCard/ItemCard';
// import dummyImage from "../../../../assets/images/dummy.png";
// import AppBar from '@material-ui/core/AppBar';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
// import _ from "lodash";
// import Button from '@material-ui/core/Button';
// import NewCategoryItemForm from '../NewCategoryItemForm/NewCategoryItemForm';
// import Drawer from '@material-ui/core/Drawer';
// import { Fab } from '@material-ui/core';
// import { ViewColumn } from '@material-ui/icons';
// import { Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';


// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     tabs: {
//       "& .MuiButtonBase-root.MuiTab-root": {
//         fontSize: 15,
//       },
//       "& .MuiTab-root": {
//         fontSize: 15,
//         color: "#FFFFFF",
//         width: 100
//       },

//       "& .Mui-selected": {
//         outline: 'none',
//         background: "white",
//         fontWeight: "bold",
//         color: "#f69516"
//       }
//     },
//     drawerPaper: {
//       height: '60%',
//       borderTopLeftRadius: 25,
//       borderTopRightRadius: 25,
//     },
//     drawerWidth: {
//       [theme.breakpoints.down(599)]: {
//         width: '90%'
//       },
//       [theme.breakpoints.up(600)]: {
//         width: '70%'
//       },
//       [theme.breakpoints.up(1025)]: {
//         width: '40%'
//       }
//     }
//   }),
// );

// function a11yProps(index) {
//   return {
//     id: `full-width-tab-${index}`,
//     "aria-controls": `full-width-tabpanel-${index}`
//   };
// }

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;
//   const customClass = props.customClass || "p-3";
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`full-width-tabpanel-${index}`}
//       aria-labelledby={`full-width-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         //   <Box p={2}>
//         <div className={customClass}>
//           {children}
//         </div>
//         //   </Box>
//       )}
//     </div>
//   );
// }

// const ServiceRequestItemForm = (props: any) => {
//   const classes = useStyles();
//   const { getRouteData, navigate, back, pageState } = useNavigationService();
//   console.log('pageState', pageState);
//   let defaultItem: any = {
//     searchText: "",
//     categoryId: 0,
//     categoryName: ""
//   };

//   if (pageState && pageState.item) {
//     defaultItem = { ...defaultItem, ...pageState.item };
//   }

//   const [item, setItem] = useState(defaultItem);
//   const routeData = getRouteData();
//   const [serviceId, setServiceId] = useState(props.serviceId ? parseInt(props.serviceId) : 0);
//   const [communityId, setCommunityId] = useState(parseInt(localstorage.getItem('communityId')));
//   const [itemDetails, setItemDetails] = useState([]);
//   const [selectedItemList, setSelectedItemList] = useState(props.selectedItems);
//   const [value, setValue] = useState(0);
//   const [categories, setCategories] = useState([]);
//   const [openCatgItemForm, setCatgItemFormOpen] = React.useState(false);
//   const [otherCategoryItems, setOtherCategoryItems] = useState(JSON.parse(session.getItem('otherCategoryItems')) ? JSON.parse(session.getItem('otherCategoryItems')) : []);

//   const handleInputChange = (item) => {
//     handleItemChange({ [item.name]: item.value });
//     getItemsByCategory({ "searchText": item.value });
//   };

//   const handleItemChange = (data) => {
//     setItem(prevState => {
//       return { ...prevState, ...data }
//     });
//   };

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const getCategories = () => {
//     let inputData = {
//       communityId: communityId,
//       serviceId: serviceId
//     }
//     let apiOptions: any = {
//       url: `category/active`,
//       data: inputData
//     };
//     http.post(apiOptions).then(response => {
//       let result = response.data;
//       getCategoriesCallBack(result);
//     });
//   }

//   const getCategoriesCallBack = (res) => {
//     let categoryList = [];
//     categoryList = res.categories;
//     let allCategories = computeCategoriesWithOtherCategoryItems(categoryList);
//     let categoryId = allCategories && allCategories.length > 0 ? allCategories[0].id : 0;
//     let categoryName = allCategories && allCategories.length > 0 ? allCategories[0].categoryName : "";
//     handleItemChange({ ["categoryId"]: categoryId });
//     handleItemChange({ ["categoryName"]: categoryName });
//     getItemsByCategory({ "categoryId": categoryId });
//   }

//   const computeCategoriesWithOtherCategoryItems = (categoryList) => {
//     if (otherCategoryItems && otherCategoryItems.length > 0) {
//       for (let item of otherCategoryItems) {
//         let newCategoryAvailable = _.filter(categoryList, { id: -1, categoryName: item.categoryName });
//         if (item.categoryId == -1 && newCategoryAvailable.length == 0) {
//           let otherCategory =
//           {
//             communityId: communityId,
//             serviceId: serviceId,
//             id: item.categoryId,
//             categoryName: item.categoryName
//           };
//           categoryList.push(otherCategory);
//         }
//       }
//     }
//     setCategories(categoryList);
//     return categoryList;
//   }

//   const tabSelect = (item: any) => {
//     handleItemChange({ ["categoryId"]: item.id });
//     handleItemChange({ ["categoryName"]: item.categoryName });
//     getItemsByCategory({ "categoryId": item.id, categoryName: item.categoryName });
//   }

//   const getItemsByCategory = (data: any) => {
//     if (data.categoryId > 0) {
//       let inputData = {
//         filters: {
//           categoryId: data.categoryId > 0 ? data.categoryId : item.categoryId,
//           name: item.searchText,
//           serviceId: serviceId,
//           communityId: communityId
//         }
//       };
//       let apiOptions: any = {
//         url: `portal/service/itemsbycategory`,
//         data: inputData
//       };
//       http.post(apiOptions).then(response => {
//         getItemsByCategoryCallback(response.data, data.categoryId);
//       });
//     }
//     else if (data.categoryId == -1) {
//       otherItems(data.categoryName);
//     }
//   }

//   const getItemsByCategoryCallback = (res, catgId) => {
//     let itemList: any = [];
//     for (let item of res) {
//       item.imageUrl = general.getImageUrl(item.imagePath);
//       item.isSelected = false;
//     }
//     itemList = res;
//     if (otherCategoryItems && otherCategoryItems.length > 0) {
//       for (let itemObj of otherCategoryItems) {
//         if (itemObj.categoryId == catgId) {
//           let otherItem =
//           {
//             communityId: communityId,
//             serviceId: serviceId,
//             id: itemObj.itemId,
//             name: itemObj.itemName
//           };
//           itemList.push(otherItem);
//         }
//       }
//     }
//     for (let item of itemList) {
//       let lookupItem = _.find(selectedItemList, { id: item.id });
//       if (lookupItem) {
//         item.isSelected = lookupItem.isSelected;
//       }
//     }
//     setItemDetails(itemList);
//   }

//   const otherItems = (catgName) => {
//     let itemList: any = [];
//     if (otherCategoryItems && otherCategoryItems.length > 0) {
//       for (let itemObj of otherCategoryItems) {
//         if (itemObj.categoryName == catgName) {
//           let otherItem =
//           {
//             communityId: communityId,
//             serviceId: serviceId,
//             id: itemObj.itemId,
//             name: itemObj.itemName,
//             categoryName: itemObj.categoryName
//           };
//           itemList.push(otherItem);
//         }
//       }
//     }
//     for (let item of itemList) {
//       let lookupItem = _.find(selectedItemList, { id: item.id, name: item.name });
//       if (lookupItem) {
//         item.isSelected = lookupItem.isSelected;
//       }
//     }
//     setItemDetails(itemList);
//   }

//   const navToSetup = () => {
//     if (selectedItemList.length == 0) {
//       AlertService.showMsg({ message: "Please select atleast one item to place service request" });
//       return;
//     }
//     props.onServiceReqFormCallback(selectedItemList);
//   }

//   const callbackItemCard = (itemObj) => {
//     if (itemObj.isSelected) {
//       if (itemObj.categoryId > 0) {
//         let lookupItem: any = _.find(categories, { id: itemObj.categoryId });
//         if (lookupItem) {
//           itemObj.categoryName = lookupItem.categoryName;
//         }
//       }
//       selectedItemList.push(itemObj);
//     }
//     else {
//       let itemIdx = _.findIndex(selectedItemList, { id: itemObj.id, name: itemObj.name });
//       selectedItemList.splice(itemIdx, 1);
//     }
//     setSelectedItemList(selectedItemList);
//   }

//   const addNewCategoryItem = () => {
//     setCatgItemFormOpen(true);
//   }

//   const handleFormClose = () => {
//     setCatgItemFormOpen(false);
//   }

//   const onSaveFormCallback = (data) => {
//     setCatgItemFormOpen(false);
//     let selectedCategoryId = item.categoryId;
//     let selectedCategoryName = item.categoryName;
//     let otherItemList: any = [];
//     if (data && data.otherCategoryItems && data.otherCategoryItems.length > 0) {
//       for (let itemObj of data.otherCategoryItems) {
//         otherItemList.push(itemObj);
//         otherCategoryItems.push(itemObj);
//       }
//     }
//     setOtherCategoryItems(otherCategoryItems);
//     session.setItem('otherCategoryItems', JSON.stringify(otherCategoryItems));
//     let categoryList: any = categories || [];
//     if (otherItemList && otherItemList.length > 0) {
//       for (let item of otherItemList) {
//         let newCategoryAvailable = _.filter(categoryList, { id: -1, categoryName: item.categoryName });
//         if (item.categoryId == -1 && newCategoryAvailable.length == 0) {
//           let otherCategory =
//           {
//             communityId: communityId,
//             serviceId: serviceId,
//             id: item.categoryId,
//             categoryName: item.categoryName
//           };
//           categoryList.push(otherCategory);
//         }
//       }
//     }
//     setCategories(categoryList);
//     if (categoryList && categoryList.length == 1) {
//       selectedCategoryId = categoryList[0].id;
//       selectedCategoryName = categoryList[0].categoryName;
//     }
//     handleItemChange({ ["categoryId"]: selectedCategoryId });
//     handleItemChange({ ["categoryName"]: selectedCategoryName });

//     let itemList: any = itemDetails || [];
//     for (let itemObj of otherItemList) {
//       if (itemObj.categoryId == selectedCategoryId && itemObj.categoryName == selectedCategoryName) {
//         let otherItem =
//         {
//           communityId: communityId,
//           serviceId: serviceId,
//           id: itemObj.itemId,
//           name: itemObj.itemName,
//           categoryName: itemObj.categoryName
//         };
//         itemList.push(otherItem);
//       }
//     }
//     setItemDetails(itemList);
//   }

//   useEffect(() => {
//     getCategories();
//   }, []);

//   return (
//     <div className="servicereq-form-ui">
//       {/* Desktop View */}
//       <div className="deskview">
//         <div className="text-center px-4 pb-4 pt-2 row justify-content-center align-items-center">
//           <div className='col-2 text-right font-17'>Select the Items and Click</div>
//           <div className='col-3 text-center'>
//             <Button variant="contained" color="primary" fullWidth
//               onClick={navToSetup} >
//               Next
//             </Button>
//           </div>
//         </div>
//         {/* <div className='col-12'>
//           <AppBar position='static'>
//             <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary"
//               variant="scrollable" scrollButtons="auto" className={classes.tabs}>
//               {
//                 categories.length > 0 && categories.map((row: any, i) => (
//                   <Tab label={row.categoryName} {...a11yProps(i)} onClick={() => tabSelect(row)} style={{ fontWeight: 600, maxWidth: "25%" }} />
//                 ))
//               }
//             </Tabs>
//           </AppBar>
//         </div> */}

//         <div className='col-12'>
//   <FormControl variant="outlined" fullWidth>
//     <InputLabel id="category-select-label">Select Category</InputLabel>
//     <Select
//       labelId="category-select-label"
//       id="category-select"
//       value={item.categoryId}
//       onChange={e => {
//         const selectedCategory = categories.find(cat => cat.id === e.target.value);
//         handleItemChange({ categoryId: e.target.value, categoryName: selectedCategory.categoryName });
//         getItemsByCategory({ categoryId: e.target.value, categoryName: selectedCategory.categoryName });
//       }}
//       label="Select Category"
//     >
//       {categories.map(cat => (
//         <MenuItem key={cat.id} value={cat.id}>{cat.categoryName}</MenuItem>
//       ))}
//     </Select>
//   </FormControl>
// </div>


//         <div className="col-12 px-5 py-5">
//           <div className='row justify-content-between px-5 pb-3'>
//             <div className="col-3">
//               {/* <FxInput name="searchText" value={item.searchText} variant="outlined" label="Search Items" fullWidth
//                 onValueChange={handleInputChange} size="small"
//               /> */}
//             </div>
//             <div className="col-4 text-center font-weight-bold">{itemDetails.length} varieties</div>
//             <div className="col-4 text-right">
//               <Fab
//                 variant="extended"
//                 size="medium"
//                 color="primary"
//                 onClick={addNewCategoryItem}
//               >
//                 <i className="fas fa-plus pr-2"></i>
//                 Add New Item
//               </Fab>
//             </div>
//           </div>


//           <div className="row">
//             {
//               itemDetails.length > 0 && itemDetails.map((itemObj, i) => (
//                 <div className="col-3">
//                   <ItemCard item={itemObj} categoryId={item.categoryId} callbackItemCard={callbackItemCard} />
//                 </div>
//               ))
//             }
//             {
//               itemDetails.length == 0 &&
//               <div className="py-5 mx-auto">
//                 <img src={dummyImage} alt="no items"></img>
//                 <div className="pt-4 font-17"><b> Sorry, No items available.</b></div>
//               </div>
//             }
//           </div>

//         </div>
//       </div>
//       <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={openCatgItemForm} onClose={handleFormClose}>
//         <NewCategoryItemForm serviceId={serviceId} onSaveFormCallback={onSaveFormCallback} handleFormClose={handleFormClose} />
//       </Drawer>
//     </div>

//   );
// }

import React, { useState, useEffect } from 'react';
import './ServiceRequestItemForm.scss';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import {
  FxInput,
  http,
  general,
  useNavigationService,
  localstorage,
  session,
  AlertService,
} from '../../../fx-core';
import ItemCard from '../ItemCard/ItemCard';
import dummyImage from '../../../../assets/images/dummy.png';
import Button from '@material-ui/core/Button';
import NewCategoryItemForm from '../NewCategoryItemForm/NewCategoryItemForm';
import Drawer from '@material-ui/core/Drawer';
import { Fab } from '@material-ui/core';
import _ from 'lodash';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerPaper: {
      height: '60%',
      borderTopLeftRadius: 25,
      borderTopRightRadius: 25,
    },
    drawerWidth: {
      [theme.breakpoints.down(599)]: { width: '90%' },
      [theme.breakpoints.up(600)]: { width: '70%' },
      [theme.breakpoints.up(1025)]: { width: '40%' },
    },
  })
);

const ServiceRequestItemForm = (props: any) => {
  const classes = useStyles();
  const { getRouteData, navigate, back, pageState } = useNavigationService();
  console.log('pageState', pageState);

  let defaultItem: any = { searchText: '', categoryId: 0, categoryName: '' };
  if (pageState && pageState.item) {
    defaultItem = { ...defaultItem, ...pageState.item };
  }

  const [item, setItem] = useState(defaultItem);
  const routeData = getRouteData();
  const [serviceId, setServiceId] = useState(
    props.serviceId ? parseInt(props.serviceId) : 0
  );
  const [communityId, setCommunityId] = useState(
    parseInt(localstorage.getItem('communityId'))
  );
  const [itemDetails, setItemDetails] = useState<any[]>([]);
  const [selectedItemList, setSelectedItemList] = useState(
    props.selectedItems || []
  );
  const [categories, setCategories] = useState<any[]>([]);
  const [openCatgItemForm, setCatgItemFormOpen] = useState(false);
  const [otherCategoryItems, setOtherCategoryItems] = useState(() =>
    JSON.parse(session.getItem('otherCategoryItems'))
      ? JSON.parse(session.getItem('otherCategoryItems'))
      : []
  );

  const handleItemChange = (data: any) => {
    setItem(prevState => ({ ...prevState, ...data }));
  };

  const getCategories = () => {
    const inputData = { communityId: communityId, serviceId: serviceId };
    const apiOptions: any = { url: 'category/active', data: inputData };
    http.post(apiOptions).then(response => {
      const result = response.data;
      getCategoriesCallBack(result);
    });
  };

  const getCategoriesCallBack = (res: any) => {
    const categoryList = res.categories || [];
    // keep otherCategoryItems' categories (for compatibility) but we won't show a dropdown filter
    const allCategories = computeCategoriesWithOtherCategoryItems(categoryList);
    setCategories(allCategories);

    // fetch items for first real category so user sees some items
    if (allCategories && allCategories.length > 0) {
      getItemsByCategory({ categoryId: allCategories[0].id });
    } else {
      // no categories from server - show only locally created items (otherCategoryItems)
      appendOtherCategoryItemsToItemDetails();
    }
  };

  const computeCategoriesWithOtherCategoryItems = (categoryList: any[]) => {
    if (otherCategoryItems && otherCategoryItems.length > 0) {
      for (const itemObj of otherCategoryItems) {
        const newCategoryAvailable = _.filter(categoryList, {
          id: -1,
          categoryName: itemObj.categoryName,
        });
        if (itemObj.categoryId == -1 && newCategoryAvailable.length == 0) {
          const otherCategory = {
            communityId: communityId,
            serviceId: serviceId,
            id: itemObj.categoryId,
            categoryName: itemObj.categoryName,
          };
          categoryList.push(otherCategory);
        }
      }
    }
    // we intentionally set categories but we won't use them for filtering in the UI
    setCategories(categoryList);
    return categoryList;
  };

  const tabSelect = (item: any) => {
    // kept for compatibility but not used in UI
    handleItemChange({ categoryId: item.id });
    handleItemChange({ categoryName: item.categoryName });
    getItemsByCategory({ categoryId: item.id, categoryName: item.categoryName });
  };

  const getItemsByCategory = (data: any) => {
    if (data && data.categoryId > 0) {
      const inputData = {
        filters: {
          categoryId: data.categoryId > 0 ? data.categoryId : item.categoryId,
          name: item.searchText,
          serviceId: serviceId,
          communityId: communityId,
        },
      };
      const apiOptions: any = {
        url: 'portal/service/itemsbycategory',
        data: inputData,
      };
      http.post(apiOptions).then(response => {
        getItemsByCategoryCallback(response.data, data.categoryId);
      });
    } else {
      // if not able to fetch from server, at least append local otherCategoryItems
      appendOtherCategoryItemsToItemDetails();
    }
  };

  const getItemsByCategoryCallback = (res: any, catgId: number) => {
    let itemList: any[] = [];
    for (const it of res) {
      it.imageUrl = general.getImageUrl(it.imagePath);
      it.isSelected = false;
      it.isExisting = true;
    }
    itemList = res;

    // IMPORTANT: Append *all* locally created items (otherCategoryItems) so they appear immediately if any
    if (otherCategoryItems && otherCategoryItems.length > 0) {
      for (const itemObj of otherCategoryItems) {
        // avoid duplicates: match by id and name
        const exists =
          _.find(itemList, { id: itemObj.itemId, name: itemObj.itemName }) ||
          _.find(itemList, { id: itemObj.itemId });
        if (!exists) {
          const otherItem = {
            communityId: communityId,
            serviceId: serviceId,
            id: itemObj.itemId,
            name: itemObj.itemName,
            categoryName: itemObj.categoryName,
            categoryId:
              itemObj.categoryId !== undefined ? itemObj.categoryId : -1,
            isSelected: false,
          };
          itemList.push(otherItem);
        }
      }
    }

    // restore selection state from selectedItemList
    for (const it of itemList) {
      const lookupItem = _.find(selectedItemList, { id: it.id });
      if (lookupItem) {
        it.isSelected = lookupItem.isSelected;
      }
    }

    setItemDetails(itemList);
  };

  const appendOtherCategoryItemsToItemDetails = () => {
    if (!otherCategoryItems || otherCategoryItems.length === 0) return;
    setItemDetails(prev => {
      const newList = [...prev];
      for (const itemObj of otherCategoryItems) {
        const exists = _.find(newList, {
          id: itemObj.itemId,
          name: itemObj.itemName,
        });
        if (!exists) {
          newList.unshift({
            communityId: communityId,
            serviceId: serviceId,
            id: itemObj.itemId,
            name: itemObj.itemName,
            categoryName: itemObj.categoryName,
            categoryId:
              itemObj.categoryId !== undefined ? itemObj.categoryId : -1,
            isSelected: false,
          });
        }
      }
      return newList;
    });
  };

  const navToSetup = () => {
    if (selectedItemList.length == 0) {
      AlertService.showMsg({
        message: 'Please select atleast one item to place service request',
      });
      return;
    }
    props.onServiceReqFormCallback(selectedItemList);
  };

  // IMPORTANT: avoid mutating state arrays in place. Use functional updates.
  const callbackItemCard = (itemObj: any) => {
    setSelectedItemList(prev => {
      const newList = [...prev];
      if (itemObj.isSelected) {
        if (itemObj.categoryId > 0) {
          const lookupItem: any = _.find(categories, { id: itemObj.categoryId });
          if (lookupItem) {
            itemObj.categoryName = lookupItem.categoryName;
          }
        } else if (!itemObj.categoryId && itemObj.categoryName) {
          // try to resolve categoryId from categories (if possible)
          const lookupByName: any = _.find(categories, {
            categoryName: itemObj.categoryName,
          });
          if (lookupByName) {
            itemObj.categoryId = lookupByName.id;
          }
        }
        // add if not present
        if (!_.find(newList, { id: itemObj.id, name: itemObj.name })) {
          // ensure the pushed object contains categoryId too
          newList.push({
            ...itemObj,
            categoryId: itemObj.categoryId !== undefined ? itemObj.categoryId : -1,
          });
        }
      } else {
        _.remove(newList, it => it.id === itemObj.id && it.name === itemObj.name);
      }
      return newList;
    });

    // also update itemDetails selection so UI updates
    setItemDetails(prev =>
      prev.map(it => {
        if (it.id === itemObj.id && it.name === itemObj.name) {
          return { ...it, isSelected: itemObj.isSelected };
        }
        return it;
      })
    );
  };

  const addNewCategoryItem = () => {
    setCatgItemFormOpen(true);
  };

  const handleFormClose = () => {
    setCatgItemFormOpen(false);
  };

const onSaveFormCallback = (data: any) => {
  // NOTE: do NOT close the drawer here (keep form open)
  // setCatgItemFormOpen(false); // <-- remove this line

  let selectedCategoryId = item.categoryId;
  let selectedCategoryName = item.categoryName;
  let otherItemList: any[] = [];

  if (data && data.otherCategoryItems && data.otherCategoryItems.length > 0) {
    for (const itemObj of data.otherCategoryItems) {
      otherItemList.push(itemObj);
    }
  }

  if (otherItemList.length === 0) return; // nothing to do

  // 1) merge into stored otherCategoryItems and persist
  const updatedOtherCategoryItems = [...otherCategoryItems, ...otherItemList];
  setOtherCategoryItems(updatedOtherCategoryItems);
  session.setItem('otherCategoryItems', JSON.stringify(updatedOtherCategoryItems));

  // 2) update categories list (kept for compatibility)
  let categoryList: any = categories ? [...categories] : [];
  for (const it of otherItemList) {
    const newCategoryAvailable = _.filter(categoryList, {
      id: -1,
      categoryName: it.categoryName,
    });
    if (it.categoryId == -1 && newCategoryAvailable.length == 0) {
      const otherCategory = {
        communityId: communityId,
        serviceId: serviceId,
        id: it.categoryId,
        categoryName: it.categoryName,
      };
      categoryList.push(otherCategory);
    }
  }
  setCategories(categoryList);

  // 3) If there were no server categories previously, set the created item's category as selected
  if (categoryList && categoryList.length === 1) {
    selectedCategoryId = categoryList[0].id;
    selectedCategoryName = categoryList[0].categoryName;
    handleItemChange({ categoryId: selectedCategoryId, categoryName: selectedCategoryName });
  }

  // 4) Immediately add the newly created items to the visible item list so user sees them without closing the form.
  // Mark them as existing: false (since they are local), and auto-select them so the user can continue.
  setItemDetails(prev => {
    const newList = [...prev];
    for (const itemObj of otherItemList) {
      const exists = _.find(newList, {
        id: itemObj.itemId,
        name: itemObj.itemName,
      });
      if (!exists) {
        newList.unshift({
          communityId: communityId,
          serviceId: serviceId,
          id: itemObj.itemId,
          name: itemObj.itemName,
          categoryName: itemObj.categoryName,
          categoryId:
            itemObj.categoryId !== undefined ? itemObj.categoryId : -1,
          isSelected: true,      // auto-select newly created
          imageUrl: null,
          isExisting: false,
        });
      } else {
        // if present, ensure it's marked selected and categoryName is applied
        exists.isSelected = true;
        exists.categoryName = itemObj.categoryName || exists.categoryName;
      }
    }
    return newList;
  });

  // 5) Add newly created items to selectedItemList (if not already present)
  setSelectedItemList(prev => {
    const newSel = [...prev];
    for (const itemObj of otherItemList) {
      const already = _.find(newSel, { id: itemObj.itemId, name: itemObj.itemName });
      if (!already) {
        newSel.push({
          communityId,
          serviceId,
          id: itemObj.itemId,
          name: itemObj.itemName,
          categoryName: itemObj.categoryName,
          categoryId: itemObj.categoryId !== undefined ? itemObj.categoryId : -1,
          isSelected: true,
        });
      } else {
        // make sure it's selected
        already.isSelected = true;
      }
    }
    return newSel;
  });

  // 6) Optionally: focus back to the NewCategoryItemForm or clear it so the user can add another item.
  // You can implement a reset signal (see note below).
};


  // ---------- Add this helper function somewhere above useEffect ----------
const fetchStallItemsAndFilter = async (navSource: any) => {
  // resolve stallId (from nav or fallback to item/serviceId/stored stall behavior)
  const stallIdFromNav =
    navSource && (navSource.stallId || navSource.stallId === 0)
      ? navSource.stallId
      : null;

  // if we don't have a stallId, try routeData/pageState props (some libs put it there)
  const stallId = stallIdFromNav || routeData?.stallId || pageState?.stallId || null;

  if (!stallId) {
    // nothing to fetch — fall back to old behaviour: categories API
    getCategories();
    return;
  }

  // selected category (may be null)
  const selCatId =
    navSource && (navSource.selectedCategoryId || navSource.selectedCategoryId === 0)
      ? navSource.selectedCategoryId
      : (navSource?.categoryId || null);

  const selCatName =
    navSource && (navSource.selectedCategoryName || navSource.selectedCategoryName === '')
      ? navSource.selectedCategoryName
      : (navSource?.categoryName || '');

  // set item so onSaveFormCallback can use this category for new items
  if (selCatId) {
    handleItemChange({ categoryId: selCatId, categoryName: selCatName || '' });
  }

  try {
    const apiOptions: any = { url: `stallitem/stall/${stallId}` };
    const res = await http.get(apiOptions);
    const raw = res.data || [];

    // normalize and filter
    const normalized: any[] = raw.map((si: any) => {
      // pick an id for UI (prefer ItemId, fallback to Id or StallItemId)
      const id = si.ItemId ?? si.Id ?? si.StallItemId ?? null;
      const name = si.ItemName ?? si.ItemName ?? (si.stallItem && si.stallItem.itemName) ?? '';
      const imagePath =
        si.ImagePath ??
        si.imagePath ??
        (si.ImagePathList && si.ImagePathList.length ? si.ImagePathList[0] : null) ??
        (si.stallItem && si.stallItem.imagePath);

      // try to get the first category id & name (items might have multiple categories)
      const categoryIds = Array.isArray(si.CategoryIds) ? si.CategoryIds : [];
      let catIdFromCategories = null;
      let catNameFromCategories = '';
      if (Array.isArray(si.Categories) && si.Categories.length > 0) {
        const firstCat = si.Categories[0];
        catIdFromCategories = firstCat.Id ?? firstCat.id ?? null;
        catNameFromCategories =
          firstCat.CategoryName ?? firstCat.categoryName ?? firstCat.Name ?? '';
      }

      // final categoryId: prefer CategoryIds array's first element, else categories array
      const categoryId = categoryIds.length > 0 ? categoryIds[0] : catIdFromCategories;
      const categoryName = categoryIds.length > 0 ? (
          // try to derive name by matching id in Categories array if present
          (Array.isArray(si.Categories) && si.Categories.find((c:any) => (c.Id ?? c.id) === categoryIds[0])?.CategoryName)
          ?? catNameFromCategories
        ) : catNameFromCategories;

      return {
        ...si,
        id,
        name,
        imagePath,
        imageUrl: imagePath ? general.getImageUrl(imagePath) : null,
        categoryId: categoryId !== undefined && categoryId !== null ? categoryId : -1,
        categoryName: categoryName || '',
        isSelected: false,
        isExisting: true  
      };
    });

    // if a selected category exists, filter by it; otherwise show all
    const filtered = selCatId
      ? normalized.filter(n => {
          // check CategoryIds array or normalized.categoryId or Categories
          if (Array.isArray(n.CategoryIds) && n.CategoryIds.length > 0) {
            return n.CategoryIds.includes(selCatId);
          }
          if (n.categoryId && n.categoryId === selCatId) return true;
          if (Array.isArray(n.Categories) && n.Categories.length > 0) {
            return n.Categories.some((c:any) => (c.Id ?? c.id) === selCatId);
          }
          return false;
        })
      : normalized;

    // Merge locally created otherCategoryItems (so they appear immediately)
    if (otherCategoryItems && otherCategoryItems.length > 0) {
      for (const other of otherCategoryItems) {
        const exists = _.find(filtered, { id: other.itemId, name: other.itemName }) || _.find(filtered, { id: other.itemId });
        if (!exists) {
          filtered.unshift({
            communityId,
            serviceId,
            id: other.itemId,
            name: other.itemName,
            categoryName: other.categoryName,
            categoryId: other.categoryId !== undefined ? other.categoryId : -1,
            isSelected: false,
            imageUrl: null,
            isExisting: false
          });
        }
      }
    }

    setItemDetails(filtered);
  } catch (err) {
    console.error('fetch stall items failed', err);
    // fallback: use local other category items only
    appendOtherCategoryItemsToItemDetails();
  }
};

// ---------- Replace your useEffect with this ----------
useEffect(() => {
  // try multiple nav payload sources
  const tryRouteData = routeData && Object.keys(routeData || {}).length ? routeData : null;
  const tryPageState = pageState && Object.keys(pageState || {}).length ? pageState : null;
  const tryLocationState = (props && (props as any).location && (props as any).location.state) ? (props as any).location.state : null;
  const tryWindowHistoryState = (window && (window as any).history && (window as any).history.state) ? (window as any).history.state : null;

  const navSource = tryRouteData || tryPageState || tryLocationState || tryWindowHistoryState || null;

  // debug - you can remove these logs later
  console.log('ServiceRequestItemForm navSource ->', navSource);
  console.log('routeData', routeData, 'pageState', pageState, 'location.state', tryLocationState, 'history.state', tryWindowHistoryState);

  // If manage items passed a selected category, we'll get it from navSource
  // and call the stall items fetch + filter routine.
  fetchStallItemsAndFilter(navSource);

  // Also fetch categories in background so local category resolution still works
  getCategories();

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  return (
    <div className="servicereq-form-ui">
      {/* Desktop View */}
      <div className="deskview">
        {/* DROPDOWN REMOVED: items shown from server (first category) plus any locally created items */}
        <div className="col-12 px-5 py-5">
          <div className="row justify-content-between px-5 pb-3">
            <div className="col-3">{/* search input could be restored here if needed */}</div>

            <div className="col-4 text-center font-weight-bold">
              {itemDetails.length} varieties
            </div>

            <div className="col-4 text-right">
              <Fab
                variant="extended"
                size="medium"
                color="primary"
                onClick={addNewCategoryItem}
              >
                <i className="fas fa-plus pr-2"></i> Add New Item
              </Fab>
            </div>
          </div>

          <div className="row">
            {itemDetails.length > 0 &&
              itemDetails.map((itemObj, i) => (
                <div className="col-3" key={`${itemObj.id}-${i}`}>
                  <ItemCard
                    item={itemObj}
                    categoryId={item.categoryId}
                    callbackItemCard={callbackItemCard}
                    isExisting={itemObj.isExisting}
                    />
                    
                </div>
              ))}

            {itemDetails.length == 0 && (
              <div className="py-5 mx-auto">
                <img src={dummyImage} alt="no items" />
                <div className="pt-4 font-17">
                  <b> Sorry, No items available.</b>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="text-center px-4 pb-4 pt-2 row justify-content-center align-items-center">
          <div className="col-2 text-right font-17">Select the Items and Click</div>
          <div className="col-3 text-center">
            <Button variant="contained" color="primary" fullWidth onClick={navToSetup}>
              Next
            </Button>
          </div>
        </div>
      </div>

      <Drawer anchor={'right'} classes={{ paper: classes.drawerWidth }} open={openCatgItemForm} onClose={handleFormClose}>
        <NewCategoryItemForm
          serviceId={serviceId}
          selectedCategoryId={item.categoryId}
          selectedCategoryName={item.categoryName}
          onSaveFormCallback={onSaveFormCallback}
          handleFormClose={handleFormClose}
        />
      </Drawer>
    </div>
  );
};

export default ServiceRequestItemForm;
